import { SceneTemplate } from "@/lib/utils/lomda/types";

export const templateA: SceneTemplate = {
    name: "תבנית א",
    branding: {
        background: "primary",
        foreground: {
            color: "secondary",
            size: {
                width: 100,
                height: 30,
            },
            location: {
                x: 0,
                y: 70,
            },
        },
    },
    aspectRatio: "16:9",
    avatar: undefined,
    scene: {
        rounded: true,
        scale: 80,
        location: {
            x: 10,
            y: 10,
        },
    },
};
